// 未保存変更確認ダイアログコンポーネント
// ルート遷移時に未保存変更がある場合に表示

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/**
 * 未保存変更確認ダイアログの結果
 */
export type UnsavedChangesDialogResult = {
  confirmed: boolean;
};

/**
 * 未保存変更確認ダイアログコンポーネント
 */
@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<UnsavedChangesDialogComponent, UnsavedChangesDialogResult>,
  );

  /** キャンセル（ページに留まる） */
  protected onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  /** ページを離れる */
  protected onConfirm(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
